"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyExecutionError = exports.EventExecutionError = exports.ExpressionExecutionError = exports.CyclicalDependencyError = exports.PathError = void 0;
exports.logError = logError;
const pi_syntax_tools_1 = require("@icg360/pi-syntax-tools");
class PathError extends Error {
    path;
    expression;
    constructor(message, path, expression) {
        super(message);
        this.name = "PathError";
        this.path = path;
        this.expression = expression;
    }
}
exports.PathError = PathError;
class CyclicalDependencyError extends Error {
    termName;
    iterableName;
    nodeType;
    constructor(message, nodeType, termName, iterableName) {
        super(message);
        this.name = "CyclicalDependencyError";
        this.nodeType = nodeType;
        this.termName = termName;
        this.iterableName = iterableName;
    }
}
exports.CyclicalDependencyError = CyclicalDependencyError;
class ExpressionExecutionError extends Error {
    expression;
    iterableIndex;
    constructor(message, expression, iterableIndex) {
        super(message);
        this.name = "ExpressionExecutionError";
        this.expression = expression;
        this.iterableIndex = iterableIndex;
    }
}
exports.ExpressionExecutionError = ExpressionExecutionError;
class EventExecutionError extends Error {
    statement;
    eventSet;
    iterableIndex;
    constructor(message, statement, eventSet, iterableIndex) {
        super(message);
        this.name = "EventExecutionError";
        this.statement = statement;
        this.eventSet = eventSet;
        this.iterableIndex = iterableIndex;
    }
}
exports.EventExecutionError = EventExecutionError;
class KeyExecutionError extends Error {
    syntax;
    termName;
    iterableName;
    constructor(message, syntax, termName, iterableName) {
        super(message);
        this.name = "EventExecutionError";
        this.syntax = syntax;
        this.termName = termName;
        this.iterableName = iterableName;
    }
}
exports.KeyExecutionError = KeyExecutionError;
function logError(e) {
    if (e instanceof PathError) {
        const message = `Path error: ${e.message} at ${(0, pi_syntax_tools_1.printSyntax)(e.path)} in expression`;
        console.error(message);
        console.error(e.expression);
        return message;
    }
    if (e instanceof ExpressionExecutionError) {
        if (e.expression.type === "count") {
            const message = `Expression execution error: "${e.message}" in count expression for ${e.expression.iterableName}`;
            console.error(message);
            console.error(e.expression);
            return message;
        }
        if (e.iterableIndex === undefined) {
            const message = `Expression execution error: "${e.message}" in ${e.expression.type} expression for terms.${e.expression.termName}`;
            console.error(message);
            console.error(e.expression);
            return message;
        }
        const message = `Expression execution error: "${e.message}" in ${e.expression.type} expression for iterables.${e.expression.iterableName}[${e.iterableIndex}].${e.expression.termName}`;
        console.error(message);
        console.error(e.expression);
        return message;
    }
    if (e instanceof EventExecutionError) {
        if (e.iterableIndex === undefined) {
            const message = `Event execution error: "${e.message}" in ${e.statement.type} statement for terms.${e.eventSet.termName}`;
            console.error(message);
            console.error(e.statement);
            console.error(e.eventSet);
            return message;
        }
        const message = `Event execution error: "${e.message}" in ${e.statement.type} statement for iterables.${e.eventSet.iterableName}[${e.iterableIndex}].${e.eventSet.termName}`;
        console.error(message);
        console.error(e.statement);
        console.error(e.eventSet);
        return message;
    }
    if (e instanceof KeyExecutionError) {
        if (e.iterableName) {
            const message = `Key execution error: "${e.message}" in key expression for iterables.${e.iterableName}`;
            console.error(message);
            console.error(e.syntax);
            return message;
        }
        if (e.termName) {
            const message = `Key execution error: "${e.message}" in key expression for terms.${e.termName}`;
            console.error(message);
            console.error(e.syntax);
            return message;
        }
        const message = `Key execution error: "${e.message}" in base key expression`;
        console.error(message);
        console.error(e.syntax);
        return message;
    }
    console.error(e);
    return String(e);
}
//# sourceMappingURL=errors.js.map